import { Spacing } from '@persona-id/design-tokens';
import { DateTime } from 'luxon';
import { VFC } from 'react';
import styled from 'styled-components';

import { InfoGrid } from 'dashboard/layouts/ShowViewLayoutV2';
import { SAR } from 'dashboard/models/sar';
import SARStatusSticker from 'dashboard/views/DashboardSARsView/SARStatusSticker';
import Attribute from 'design-system/components/Attribute';
import Card from 'design-system/components/Card';
import { DATE_AND_TIME_TZ_FORMAT } from 'lib/constants/luxonFormats';

const TitleContainer = styled('div')`
  display: grid;
  grid-column-gap: ${Spacing[2]};
  grid-template-columns: auto auto;
  align-items: center;
`;

interface SARInfoCardProps {
  sar: SAR;
}

export const SARInfoCard: VFC<SARInfoCardProps> = ({ sar }) => {
  const {
    name,
    status,
    'created-at': createdAt,
    'updated-at': updatedAt,
    'bsa-id': bsaId,
  } = sar.attributes;

  return (
    <Card>
      <Card.Body>
        <TitleContainer>
          <Card.Title>
            <TitleContainer>
              {name}
              <SARStatusSticker status={status} />
            </TitleContainer>
          </Card.Title>
        </TitleContainer>

        <InfoGrid>
          <Attribute
            label='Created at'
            value={createdAt ? DateTime.fromISO(createdAt).toFormat(DATE_AND_TIME_TZ_FORMAT) : null}
          />
          <Attribute
            label='Last updated'
            value={updatedAt ? DateTime.fromISO(updatedAt).toFormat(DATE_AND_TIME_TZ_FORMAT) : null}
          />
          <Attribute label='BSA ID' value={bsaId} />
        </InfoGrid>
      </Card.Body>
    </Card>
  );
};
